<template>
  <div>
    <img class="loader-spinner" :src="Loader" alt="SID Loader" />
    <div class="loading-desription">
      {{ instruction ? instruction : 'Loading...' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidLoader',
  props: {
    instruction: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      Loader: require('../../assets/images/loader_excluded_264x264.gif'),
    }
  },
}
</script>

<style scoped lang="scss">
.loader-spinner {
  display: inline-block;
  width: 132px;

  @media screen and (max-width: $mobile-resolution) {
    width: 132px;
  }
}

.loading-desription {
  font-size: 16px;
  color: #0a0908;
  margin-top: 8px;

  @media screen and (max-width: $mobile-resolution) {
    width: 80%;
    margin: 10px auto;
  }
}
</style>
